import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const styles = () => ({
  root: {},
});

const FirstWinViewButton = ({
  className,
  classes,
}) => {
  const { pageContentResource, loadPageContentLink } = usePageContentContext();

  return (
    <RoundedButton
      className={classNames(classes.root, className)}
      onClick={() => {
        return loadPageContentLink(pageContentResource.relationship(fr.relationships.firstWinView.name).link('related'));
      }}
    >
      {'First Win View'}
    </RoundedButton>
  );
};

FirstWinViewButton.defaultProps = {
  className: '',
};

FirstWinViewButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FirstWinViewButton);
